// Cache for repayment dates to avoid unnecessary API calls
class RepaymentDatesCache {
  constructor() {
    this.cache = null;
    this.timestamp = null;
    this.loanAmount = null;
    this.cacheExpiry = 5 * 60 * 1000; // 5 minutes in milliseconds
  }

  // Check if cache is valid (exists and not expired)
  isValid() {
    if (!this.cache || !this.timestamp) {
      return false;
    }
    
    const now = Date.now();
    return (now - this.timestamp) < this.cacheExpiry;
  }

  // Get cached data if valid
  get() {
    if (this.isValid()) {
      return this.cache;
    }
    return null;
  }

  // Set cache data with current timestamp
  set(data, loanAmount = null) {
    this.cache = data;
    this.timestamp = Date.now();
    this.loanAmount = loanAmount;
  }

  // Clear cache
  clear() {
    this.cache = null;
    this.timestamp = null;
    this.loanAmount = null;
  }

  // Get cache age in seconds
  getAge() {
    if (!this.timestamp) return null;
    return Math.floor((Date.now() - this.timestamp) / 1000);
  }

  // Get cached loan amount
  getLoanAmount() {
    return this.loanAmount;
  }
}

// Create a singleton instance
const repaymentDatesCache = new RepaymentDatesCache();

export default repaymentDatesCache; 